import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Apiservice from "../Apiservice";
import { formatDateTimeQuiz } from '../Utils/Utils'

const Quiz = ({ userId, userDetails, setQuizSummary }) => {
    const { examId } = useParams();
    const { user_id } = useParams();
    const navigate = useNavigate();
    const [localQuizSummary, setLocalQuizSummary] = useState([]);
    const [loading, setLoading] = useState(true);
    const [logInRoleId, setLogInRoleId] = useState(0);

    useEffect(() => {
        const roleId = localStorage.getItem('role_id');
        setLogInRoleId(roleId);
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            const data = examId > 0
                ? {
                    user_id: localStorage.getItem("user_id"),
                    exam_id: examId,
                    status: 0,
                }
                : {
                    user_id: user_id || localStorage.getItem("user_id"),
                    status: 0,
                };

            const headers = {
                access_token: localStorage.getItem("access_token"),
            };

            const result = examId > 0
                ? await Apiservice.GetQuizSummaryByUserExam(data, headers)
                : await Apiservice.GetQuizSummaryByUser(data, headers);

            setLoading(false);

            if (result?.success) {
                const quizData = Array.isArray(result.data) ? result.data : [];
                setLocalQuizSummary(quizData);     // Local rendering
                setQuizSummary?.(quizData);        // Parent update if provided
                console.log("quizData", quizData)
            } else {
                console.log("Quiz fetch failed", result);
            }
        };

        fetchData();
    }, [examId, userId, user_id, setQuizSummary]);

    const handleReview = (summary) => {
        navigate(`/quizreview/${summary.id}`, { state: { userDetails } });
    };

    const handleEdit = (summary) => {
        navigate('/quizedit', {
            state: {
                quizId: summary.id,
                examId: summary.exam_id,
            }
        });
    };

    return (
        <div className="container-fluid py-4" style={{ backgroundColor: "#f8f9fa", userSelect: 'none' }}>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status" style={{ width: "2rem", height: "2rem", borderWidth: "3px" }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                    </div>
                </div>
            ) : (
                <>
                    {examId > 0 && (
                        <div className="alert alert-info text-center" role="alert">
                            <p className="mb-0">
                                Answer all the questions correctly. You can reattempt the questions until you get them all correct.
                            </p>
                        </div>
                    )}

                    <div className="text-center mb-4">
                        <h4 className="fw-bold">
                            {userId > 0 ? "SUMMARY OF PREVIOUS RECORDS" : "SUMMARY OF YOUR PREVIOUS RECORDS"}
                        </h4>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover table-bordered text-center">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Exam</th>
                                    <th>Attempt</th>
                                    <th>Status</th>
                                    <th>Marks</th>
                                    <th>Grade</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {localQuizSummary.length > 0 ? (
                                    localQuizSummary.map((summary, index) => {
                                        let state = {};
                                        try {
                                            state = JSON.parse(summary.state || '{}');
                                        } catch (err) {
                                            console.warn("Invalid state JSON", err);
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{summary.examName?.[0]?.name || "No Exam Name"}</td>
                                                <td>{summary.attempt}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${summary.grade >= 70
                                                                ? "bg-success"
                                                                : "bg-danger"
                                                            }`}
                                                    >
                                                        {summary.grade >= 70
                                                            ? "Pass"
                                                            : "Fail"}
                                                    </span>
                                                    <div className="small text-muted">
                                                        <div>Start: {formatDateTimeQuiz(state.startTime)}</div>
                                                        <div>End: {formatDateTimeQuiz(state.endTime)}</div>
                                                        <div>Duration: {state.timeTaken}</div>
                                                        <div>Question Attend: {summary.questionAttempt}</div>
                                                    </div>
                                                </td>
                                                <td>{summary.mark} / {summary.noOfQuestions}</td>
                                                <td>{summary.grade} % </td>
                                                <td>
                                                    <button className="btn btn-sm btn-primary m-2" onClick={() => handleReview(summary)}>
                                                        Review
                                                    </button>
                                                    {
                                                        (logInRoleId === 1 || logInRoleId === '1') && (
                                                            <button
                                                                className="btn btn-sm btn-primary m-2"
                                                                onClick={() => handleEdit(summary)}
                                                            >
                                                                Edit
                                                            </button>
                                                        )
                                                    }

                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-3">
                                            You have Zero Attempts
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {examId > 0 && (
                        <div className="text-center mt-4">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => navigate(`/quiztest/${examId}`)}
                            >
                                Continue your Attempt
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Quiz;
